import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import Soulspace from './Soulspace';
import PortalButton from '../components/PortalButton';

export default function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/community', label: 'Community' },
    { path: '/about', label: 'About' },
    { path: '/get-started', label: 'Get Started' },
    { path: '/try', label: 'Try for Free', isPill: true },
  ];

  return (
    <nav className="relative">
      {/* Desktop Navigation */}
      <div className="hidden md:flex items-center justify-between w-full">
        {/* Left: Navigation Links */}
        <div className="flex items-center space-x-6 lg:space-x-8">
          {navItems.map(({ path, label, isPill }) => (
            isPill ? (
              <Link
                key={path}
                to={path}
                className={`font-semibold text-sm px-4 py-1.5 rounded-full border transition-all duration-300 hover:scale-105 ${
                  location.pathname === path
                    ? 'bg-indigo-500 border-indigo-400 text-white shadow-lg shadow-indigo-500/30'
                    : 'bg-indigo-600 border-indigo-500 text-white hover:bg-indigo-500 shadow-md shadow-indigo-600/20'
                }`}
              >
                ✦ {label}
              </Link>
            ) : (
              <Link
                key={path}
                to={path}
                className={`font-semibold hover:text-yellow-200 transition-colors duration-300 relative after:content-[''] after:absolute after:w-full after:h-0.5 after:left-0 after:bottom-0 after:bg-linear-to-r after:from-yellow-300 after:to-indigo-500 after:scale-x-0 after:origin-left hover:after:scale-x-100 after:transition-transform after:duration-500 ${
                  location.pathname === path
                    ? 'text-yellow-200 after:scale-x-100'
                    : 'text-indigo-200'
                }`}
              >
                {label}
              </Link>
            )
          ))}
        </div>

        {/* Right: Soulspace + Portal Button */}
        <div className="flex items-center space-x-4 lg:space-x-6">
          <Soulspace />
          <PortalButton />
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className="md:hidden">
        {/* Mobile Header with Menu Toggle */}
        <div className="flex items-center justify-between py-2">
          <div className="flex items-center space-x-4">
            <Soulspace />
          </div>
          
          <div className="flex items-center space-x-3">
            <PortalButton label="Sanctuary" />
            <button
              className="p-2 rounded-lg bg-white/10 hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-colors"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle navigation menu"
              aria-expanded={menuOpen}
            >
              <svg 
                className={`w-6 h-6 transition-transform duration-300 ${menuOpen ? 'rotate-90' : ''}`} 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                viewBox="0 0 24 24"
              >
                {menuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        <div className={`overflow-hidden transition-all duration-300 ease-in-out ${
          menuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}>
          <div className="py-4 space-y-2 border-t border-white/20 bg-black/20 rounded-b-lg">
            {navItems.map(({ path, label, isPill }) => (
              <Link
                key={path}
                to={path}
                className={`block px-4 py-3 font-semibold rounded-lg mx-2 transition-all duration-300 ${
                  isPill
                    ? location.pathname === path
                      ? 'bg-indigo-500 text-white shadow-lg'
                      : 'bg-indigo-600/70 text-white hover:bg-indigo-500'
                    : location.pathname === path
                    ? 'bg-indigo-600 text-white shadow-lg'
                    : 'text-indigo-200 hover:text-white hover:bg-white/10'
                }`}
                onClick={() => setMenuOpen(false)}
              >
                {isPill ? `✦ ${label}` : label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}
